import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { navBar } from "@web/theme/theme";

export type NavBarProps = {
  title: ReactNode;
  /** Renders a back chevron on the left. */
  onBack?: () => void;
  /** Trailing action (e.g. a `+`). Use `NavBarAction`. */
  trailing?: ReactNode;
  className?: string;
  subtitle?: string;
};

/** Sticky top bar with safe-area padding; title centered between two 44px slots. */
export function NavBar({ title, onBack, trailing, className = "", subtitle }: NavBarProps) {
  return (
    <header className={`${navBar.base} ${className}`.trim()}>
      <div className={navBar.inner}>
        <div className="flex items-center min-w-tap">
          {onBack && <NavBarAction label="Back" icon={<ChevronLeft aria-hidden size={26} />} onClick={onBack} />}
        </div>
        <div className="v365-nav-heading"><h1 className={navBar.title}>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
        <div className="flex items-center justify-end min-w-tap">{trailing}</div>
      </div>
    </header>
  );
}

export type NavBarActionProps = { label: string; icon: ReactNode; onClick?: () => void; showLabel?: boolean; disabled?: boolean; disabledReason?: string | null };

export function NavBarAction({ label, icon, onClick, showLabel, disabled, disabledReason }: NavBarActionProps) {
  return (
    <button type="button" aria-label={label} title={disabledReason || label} disabled={disabled} onClick={onClick} className={`${navBar.action} ${showLabel ? "v365-header-action" : ""}`}>
      {icon}
      {showLabel && <span>{label}</span>}
    </button>
  );
}
